<template>
  <div class="this-page" v-if="load.result">
    <template>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>系统设置</el-breadcrumb-item>
        <el-breadcrumb-item>员工设置</el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <template>
      <el-table :data="result" stripe style="width: 100%;margin-top:20px" :fit="true" size="small"  :height="tableHeight">
        <el-table-column prop="id" label="编号">
        </el-table-column>
        <el-table-column prop="name" label="姓名">
        </el-table-column>
        <el-table-column prop="account" label="账号">
        </el-table-column>
        <el-table-column prop="value" label="充值权限">
          <template slot-scope="scope">
            <el-switch
                v-model="scope.row.authority_charge == 1"
                active-color="#13ce66"
                inactive-color="#ff4949"
                @change="updateStaff(scope.row.id,'authority_charge',scope.row.authority_charge == 1?0:1)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="value" label="管理权限">
          <template slot-scope="scope">
            <el-switch
                v-model="scope.row.authority_manage_staff == 1"
                active-color="#13ce66"
                inactive-color="#ff4949"
            @change="updateStaff(scope.row.id,'authority_manage_staff',scope.row.authority_charge == 1?0:1)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="value" label="启用">
          <template slot-scope="scope">
            <el-switch
                v-model="scope.row.disabled == 1?false:true"
                active-color="#13ce66"
                inactive-color="#ff4949"
                @change="updateStaff(scope.row.id,'disabled',scope.row.disabled == 1?0:1)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="操作"  >
          <template slot-scope="scope">
            <el-button size="small" icon="el-icon-edit" @click="updatePwd(scope.row.id)" type="danger">修改密码</el-button>

          </template>
        </el-table-column>
      </el-table>
      <el-button size="small" icon="el-icon-edit" @click="dialogFormVisible = true" style="margin-top: 20px">新增员工账户</el-button>
    </template>
    <el-dialog title="新增员工账号" :visible.sync="dialogFormVisible" width="500px">
      <el-form :model="form">
        <el-form-item label="姓名">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="登陆账户名">
          <el-input v-model="form.account" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="登陆密码">
          <el-input v-model="form.pwd" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addStaff()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableHeight: document.documentElement.clientHeight - 210 + 'px',
      load: {
        result: false
      },
      result:[],
      dialogFormVisible:false,
      form:{
        name:"",
        account:"",
        pwd:""
      }
    }
  },
  mounted() {
    var that = this;
    // <!--把window.onresize事件挂在到mounted函数上-->
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;

        that.tableHeight = window.fullHeight - 165 + 'px';  // 高

      })()
    };
    this.getStatistics()

  },
  methods: {
    getStatistics() {
      this.load.result = false
      this.result = []
      this.$fetch.post('Setting/getStaff', {}, true).then(res => {
        this.load.result = true
        this.result = res
      })
    },
    updatePwd(id){
      this.$prompt(name, '修改密码', {
        confirmButtonText: '确定修改',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        this.$fetch.post('Setting/updateStaff', {id:id,key:'pwd',value:value}, true).then(res => {
          this.$message({
            type: 'success',
            message: '修改完成'
          });
          this.getStatistics()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消修改'
        });
      });
    },
    updateStaff(id,key,value){
      this.$fetch.post('Setting/updateStaff', {id,key,value}, true).then(res => {
        this.$message({
          type: 'success',
          message: '修改完成'
        });
        this.getStatistics()
      })
    },
    addStaff(){
      if(!this.form.name){
        this.$message({
          type: 'info',
          message: '请输入姓名'
        });
        return
      }
      if(!this.form.account){
        this.$message({
          type: 'info',
          message: '请输入登陆账号'
        });
        return
      }
      if(!this.form.pwd){
        this.$message({
          type: 'info',
          message: '请输入登陆密码'
        });
        return
      }
      this.$fetch.post('Setting/addStaff', {name:this.form.name,pwd:this.form.pwd,account:this.form.account}, true).then(res => {
        this.$message({
          type: 'success',
          message: '新增完成'
        });
        this.form.name = ''
        this.form.pwd = ''
        this.form.account = ''
        this.dialogFormVisible = false
        this.getStatistics()
      })
    }
  }
}
</script>

<style scoped>
.this-page {
  padding: 20px;
  background-color: #FFFFFF;

}
.count{
  padding:10px 0;
}
.count span{
  font-size: 30px;
  padding: 0 10px;
}
.timer{
  padding: 20px 0;
  padding-bottom: 0;
}
</style>
